<article class="upload">
	<stages-dropzone
		[maxFileSize]="maxFileSize()"
		[multiple]="multiple()"
		[fileExtensions]="fileExtensions()"
		[expandDroparea]="expandDroparea()"
		(handleFiles)="handleFilesUpdated($event)"
	></stages-dropzone>
	@if (errors.invalid) {
		<div class="error">{{ "files.upload.invalid" | translate }}</div>
	}

	<stages-progress-bar [progress]="progress!" iconClass="{{ uploadIcon() }}" [hidden]="!progress"></stages-progress-bar>
</article>
